"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSamePotagerWeek = exports.isNextWeek = exports.isNextPotagerWeek = exports.isDatePassed = void 0;
var date_fns_1 = require("date-fns");
var isDatePassed = function (date) {
    var now = new Date().setHours(0, 0, 0, 0);
    var d = new Date(date * 1000).setHours(0, 0, 0, 0);
    return d < now;
};
exports.isDatePassed = isDatePassed;
var isNextPotagerWeek = function (date) {
    var nextThursdayTimestamp = (0, date_fns_1.getUnixTime)((0, date_fns_1.nextThursday)(new Date()));
    var dateTimestamp = (0, date_fns_1.getUnixTime)((0, date_fns_1.isDate)(date) ? date : (0, date_fns_1.fromUnixTime)(date));
    return dateTimestamp > nextThursdayTimestamp;
};
exports.isNextPotagerWeek = isNextPotagerWeek;
var isNextWeek = function (date) {
    var nextMondayTimestamp = (0, date_fns_1.getUnixTime)((0, date_fns_1.addDays)((0, date_fns_1.startOfWeek)(new Date()), 7));
    var dateTimestamp = (0, date_fns_1.isDate)(date) ? (0, date_fns_1.getUnixTime)(date) : date;
    return dateTimestamp > nextMondayTimestamp;
};
exports.isNextWeek = isNextWeek;
var isSamePotagerWeek = function (date1, date2) {
    return (0, date_fns_1.isSameWeek)((0, date_fns_1.isDate)(date1) ? date1 : (0, date_fns_1.fromUnixTime)(date1), (0, date_fns_1.isDate)(date2) ? date2 : (0, date_fns_1.fromUnixTime)(date2), { weekStartsOn: 4 });
};
exports.isSamePotagerWeek = isSamePotagerWeek;
exports.default = { isDatePassed: exports.isDatePassed, isNextPotagerWeek: exports.isNextPotagerWeek, isNextWeek: exports.isNextWeek, isSamePotagerWeek: exports.isSamePotagerWeek };
//# sourceMappingURL=DateCheck.js.map